<template>
  <div class="w100 po-r bg-w pt20 pb20 pl20 pr20">
    <div class="w100 mb20 cl-f">
      <span class="font-16">服务异常管理</span>
      <div class="flex-box fr">
        <el-input class="mr10" placeholder="查询" size="mini" prefix-icon="el-icon-search" v-model="searchText" @keyup.enter.native="initPage" clearable></el-input>
        <el-button type="primary" size="mini" @click="initPage">查询</el-button>
      </div>
    </div>

    <div class="w100 po-r pt20">
      <el-table class="w100 tx-c my-table" :data="list" stripe border @row-click="clickRow">
        <el-table-column align="center" label="序号" width="60px">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务名称" prop="processName"></el-table-column>
        <el-table-column header-align="center" label="事务标题" prop="processTitle" width="240px"></el-table-column>
        <el-table-column align="center" label="申请人" prop="createUser" width="120px"></el-table-column>
        <el-table-column align="center" label="申请时间" width="150px">
          <template slot-scope="scope">
            {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="已超时" width="150px">
          <template slot-scope="scope">
            {{ scope.row.expireTime | costTime }}
          </template>
        </el-table-column> -->
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="isShow" width="1000px" top="10px">
      <iframe ref="iframe" class="iframe" :src="isShow ? iframeUrl : ''"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OfficeBizException",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      searchText: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      list: [],

      isShow: false,
      iframeUrl: ""
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.initPage();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "serve/manager/queryException",
          this.$qs.stringify({
            serveTitle: this.searchText,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    clickRow(item) {
      this.isShow = true;
      this.iframeUrl = item.formUrl || item.taskUrl || item.trackUrl;
      // this.iframeUrl += "&time" + new Date().getTime();
      // console.log(this.iframeUrl);
      this.$nextTick(() => {
        window.addEventListener("message", e => {
          if (e.data.iframeHide) {
            this.isShow = false;
            this.iframeUrl = "";

            this.fetchList();
          }
        });

        this.$refs.iframe.onload = () => {
          const af = this.$refs.iframe.contentWindow["AWSFormMainAPI"];
          af.customCloseFormPage(() => {
            this.isShow = false;
            this.fetchList();
            return true;
          });
        };
      });
    }
  },
  watch: {}
};
</script>

<style scoped>
.iframe {
  position: relative;
  border: none;
  height: calc(100vh - 75px);
}
</style>
